<template>
    <div class="ops-optimize-templates" @click="clicked">
        <RouterView :loaded="loaded" @filter="filter" :key="$route.path" />

        <teleport to="body">
            <modals-container></modals-container>
        </teleport>

        <div class="opm-loading-indicator sk-pulse"></div>
    </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useFiltersStore } from '../store/filters'
import { useSettingsStore } from '../store/settings'
import { useTemplatesStore } from '../store/templates'

export default {
    data() {
        return {
            filtersStore: useFiltersStore(),
            templatesStore: useTemplatesStore(),
            settingsStore: useSettingsStore(),
            filtersHidden: false,
            loaded: false,
        }
    },
    computed: {
        ...mapStores(useFiltersStore, useSettingsStore, useTemplatesStore),
    },
    // No need to watch route change. The filter event will be emited in
    // templates/pages/Library.vue::mounted.
    //
    // watch: {
    //     $route(to, from) {
    //         this.loaded = false
    //         this.filter()
    //     },
    // },
    methods: {
        async filter() {
            this.loaded = false
            await this.templatesStore.fetchTemplates()
            this.loaded = true
        },

        clicked() {
            this.$events.emit('clickedOutside')
        },
    },
}
</script>
